export const calcularTasaEA = (tasaMensual) => {
    const tasaDecimal = tasaMensual / 100;
    const tasaEA = (Math.pow(1 + tasaDecimal, 12) - 1) * 100;
    return tasaEA.toFixed(2);
};

export const calcularCuotaFinal = ({ monto, plazo, tasa, seguro, diasLibranza = 0, tipoConvenio = 'NORMAL' }) => {
    const montoFloat = parseFloat(monto);
    const tasaMensual = tasa / 100;
    const n = parseInt(plazo, 10);
    const dias = parseInt(diasLibranza || 0, 10);

    // Tarifa de seguro fija por tipo de convenio (valor por millón)
    const tipoConvenioStr = tipoConvenio?.name || tipoConvenio?.key || tipoConvenio || '';
    const tarifaSeguro = tipoConvenioStr.toString().toUpperCase().includes('ESPECIAL') ? 1000 : 667;
    // ! Additional interest for payroll loan days
    const interesAdicional = montoFloat * (tasaMensual * 12) * (dias / 360);
    const valorTotal = montoFloat + interesAdicional;

    // * French system calculation
    const cuotaBase = valorTotal * (tasaMensual * Math.pow(1 + tasaMensual, n)) /
        (Math.pow(1 + tasaMensual, n) - 1);

    // ? Insurance calculation
    const valorSeguro = Math.round((montoFloat * tarifaSeguro) / 1_000_000);

    let cuotaFinal = cuotaBase + valorSeguro;
    if (seguro) {
        const factorProtegido = 1.0603;
        cuotaFinal *= factorProtegido;
    }

    const cuotaTotal = Math.round(cuotaFinal);
    
    return {
        cuota: cuotaTotal,
        valorSeguro,
        tasaEA: calcularTasaEA(tasa)
    };
};